import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import PlanningGroupListLayer from '../components/PlanningGroupListLayer';

const PlanningGroupPage = () => {
  return (
    <>
      <MasterLayout pageTitle='Planning Groups'>
        <PlanningGroupListLayer />
      </MasterLayout>
    </>
  );
};

export default PlanningGroupPage;
